import PropTypes from "prop-types";
import React from "react";

import { createClassNameString } from "@/utils/createClassNameString";

import { Button } from "../Button";
import { ButtonTypes } from "../constants";
import { CloseIcon } from "../../components/Icons/CloseIcon";
import { getAutomationDataAttr } from "../../utils/automationUtils";
import { ICON_SIZES, ICON_TYPES } from "../../constants/icons";
import { Modal } from "../Modal";
import { testLocator } from "../../lib/helpers/test-locator";
import { Text } from "../Text";

import "./styles.scss";

export const preventModalPageScroll = (isOpen) => {
  if (isOpen) {
    document.body.classList.add("modal-open");
  } else {
    document.body.classList.remove("modal-open");
  }
};

export const ScrollableTextModal = ({
  bodyContent,
  captchaComponent,
  cardClassName,
  className,
  onCancel,
  onSubmit,
  show,
  submitButtonTestId,
  submitButtonText,
  submitDisabled,
  testId,
  title,
  ...props
}) => {
  const SMALL_SCREEN_SIZE = 421;

  const isSmallScreen = window.innerWidth < SMALL_SCREEN_SIZE;

  return (
    <Modal
      cardClassName={cardClassName}
      className={createClassNameString([className, "apti-ScrollableTextModal"])}
      show={show}
      {...props}
    >
      <div className="apti-ScrollableTextModal__header">
        <div className="apti-ScrollableTextModal__header-text">
          <Text className="apti-ScrollableTextModal__header-text-heading">{title}</Text>
        </div>
        <CloseIcon
          className="apti-ScrollableTextModal__cancel"
          iconSize={ICON_SIZES.SMALL}
          iconType={ICON_TYPES.OUTLINE}
          onClick={onCancel}
        />
      </div>

      <div className="apti-ScrollableTextModal__scroller">
        <div className="apti-ScrollableTextModal__scroller-body">{bodyContent}</div>
      </div>
      {captchaComponent && captchaComponent}
      <div className={createClassNameString([className, "apti-ScrollableTextModal__buttons"])}>
        <Button
          buttonType={ButtonTypes.primaryV2}
          className={`apti-ScrollableTextModal__button ${
            isSmallScreen ? "full-width" : "wide-width"
          }`}
          disabled={submitDisabled}
          onClick={onSubmit}
          {...getAutomationDataAttr(`${testId}_submit-button`)}
          {...testLocator(submitButtonTestId)}
        >
          {submitButtonText}
        </Button>
      </div>
    </Modal>
  );
};

ScrollableTextModal.propTypes = {
  bodyContent: PropTypes.element,
  className: PropTypes.string,
  onCancel: PropTypes.func,
  onSubmit: PropTypes.func,
  show: PropTypes.bool,
  submitButtonText: PropTypes.string,
  title: PropTypes.string,
};

ScrollableTextModal.defaultProps = {
  className: undefined,
  onSubmit: () => {},
  show: false,
  submitButtonText: "Agree",
  title: "",
};
